var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.33333C9.6318 1.33333 9.33333 1.63181 9.33333 2C9.33333 2.18428 9.4072 2.35003 9.5286 2.47141C9.65 2.59278 9.81573 2.66667 10 2.66667C10.3682 2.66667 10.6667 2.36819 10.6667 2C10.6667 1.63181 10.3682 1.33333 10 1.33333ZM8 2C8 0.895433 8.8954 0 10 0C11.1046 0 12 0.895433 12 2C12 3.10457 11.1046 4 10 4C9.69147 4 9.39893 3.92987 9.13787 3.80496L3.80496 9.13787C3.92987 9.39893 4 9.69147 4 10C4 11.1046 3.10457 12 2 12C0.895433 12 0 11.1046 0 10C0 8.8954 0.895433 8 2 8C2.30852 8 2.60105 8.07013 2.86215 8.19507L8.19507 2.86215C8.07013 2.60105 8 2.30852 8 2ZM2 9.33333C1.63181 9.33333 1.33333 9.6318 1.33333 10C1.33333 10.3682 1.63181 10.6667 2 10.6667C2.36819 10.6667 2.66667 10.3682 2.66667 10C2.66667 9.81573 2.59278 9.65 2.47141 9.5286C2.35003 9.4072 2.18428 9.33333 2 9.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.8b06da3a46893f57a45b1b62d960976f.svg";
export { ForwardRef as ReactComponent };